import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import frLocale from 'date-fns/locale/fr';
import {
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { useEffect, useMemo } from 'react';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import { translate } from 'containers/services/translate';
import SahamAccordion from 'components/SahamAccordion';
import { LABEL_WIDTH } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/constants';
import { Config, Listings, SagisConfig } from 'containers/AppContainer/typings';
import { REGULATIONS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { DATE_FORMAT, DATE_PICKET_FORMAT } from 'constants/global';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import {
  getCheckedBeneficiaries,
  getDocumentNature,
  getJomValidatorMessage,
  getRisks,
  formatDate,
  getCurrentRegulationNature,
  getLinkWithRecepient,
  beneficiaryRecipientCases,
  getChosenCity,
  getJudgementOnMeritsByTargetValue,
  getJudiciarySettlementChannel,
  setPaymentChannelByBeneficiaryRecipient,
  getUpdatedJudgementOnMerits,
  getPaymentNature,
  getLinkWithRecepientForMaterialRisk,
  numberWithCommas,
  getAppealDates,
  checkIsAppealProcess,
  hasAllProcedureTypes,
  setJudgementDate,
  paymentMethod,
  getSharedResponsibility,
  getRecipientWhenFraud,
  getRegulationRecipient,
  isNatureRegulationPartial,
  isCDRATownDifferent,
  formatProcedureNatureIds,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import {
  CALCULATION_START_DATE,
  COURT_NUMBER,
  DOCUMENT_NATURE,
  IDD,
  JUDGEMENT_DATE,
  NONE,
  RECIPIENT,
  JUDGEMENT_ID_JOM,
  MOROCCO_COUNTRY,
  OPPOSING_LAWYER,
  REGULATION_JUDGEMENT_PROCEDURE_TYPE,
  PROCESS_NATURE_MAPPER,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import {
  getCities,
  getCountriesWithCities,
} from 'containers/RecapManagerPage/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import {
  DEDUCTION_NO_RATE_IDD,
  DEDUCTION_RATE_IDD,
  IDD_CHECK,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { STATUS_VALIDATED_WITHOUT_CONTESTATION } from 'containers/LawyerFeeNote/constants';
import { validationCourtFileNumber } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { removeDeletedAssignement } from 'services/utils';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { LISTINGS } from 'containers/data-structure';
import { ClaimRecapType } from 'typings/claimTypes';

export interface RegulationInformationByRiskProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  setRiskRecap: Function;
  riskRecap: any;
  listings: Listings;
  judgementOnMerits: any;
  risk: any;
  requestGetJudgementOnMerits: Function;
  activeStep: number;
  isRegulationValidated: any;
  riskData: any;
  substituteDocumentNature: SagisConfig[];
  setSubstituteDocumentNature: Function;
  isStepValidated: any;
  setMessageError: Function;
  messageError: any;
  setIsStepValidated: Function;
  isJomValidated: any;
  requestGetAssignedLawyers: Function;
  judgementOnMeritsWithCivjvm: any;
  isBasicManagementRegulation?: boolean;
  judgementNatureProcedureIds: any;
}

export const RegulationInformationByRisk: React.FC<RegulationInformationByRiskProps> = ({
  sagisClaim,
  claimRecap,
  listings,
  risk,
  judgementOnMerits,
  requestGetJudgementOnMerits,
  activeStep,
  isRegulationValidated,
  substituteDocumentNature,
  setSubstituteDocumentNature,
  riskData,
  isStepValidated,
  setMessageError,
  messageError,
  setIsStepValidated,
  isJomValidated,
  ...props
}): JSX.Element => {
  const { rcCorpo, rcMaterial } = getRisks(props.riskRecap);

  const IDD_LIST = [
    { id: 1, value: translate(messages.iddConfirm, props) },
    { id: 2, value: translate(messages.iddRefuse, props) },
  ];
  const judiciaryChannel = useMemo(
    () =>
      getJudiciarySettlementChannel(
        get(listings, 'PaymentChannel', []),
        get(listings, 'PaymentNature', []),
        risk,
        props.riskRecap,
        props.setRiskRecap,
      ),
    [listings],
  );

  useEffect(() => {
    const judgementOnMeritsByValue = getJudgementOnMeritsByTargetValue(
      judgementOnMerits,
      get(rcCorpo, 'regulationInfo.judgementDate', {}) !== NONE
        ? get(rcCorpo, 'regulationInfo.judgementDate', {})
        : get(rcCorpo.regulationInfo, REGULATIONS.JUDGEMENT_DATE_JAF, null),
    );
    risk.riskName === RISK_NAME.CORPOREAL &&
      setSubstituteDocumentNature(
        getDocumentNature(
          get(listings, 'EncryptDocumentNature', []),
          judgementOnMeritsByValue,
          rcCorpo,
          sagisClaim,
          false,
          get(listings, 'PaymentStatus', []),
          props.isBasicManagementRegulation,
        ),
      );
  }, [
    judgementOnMerits,
    get(rcCorpo, 'regulationInfo.judgementDate', null) !== NONE
      ? get(rcCorpo, 'regulationInfo.judgementDate', null)
      : get(rcCorpo.regulationInfo, REGULATIONS.JUDGEMENT_DATE_JAF, null),
  ]);
  useEffect(() => {
    const judgementOnMeritsByValue = getJudgementOnMeritsByTargetValue(
      judgementOnMerits,
      get(rcCorpo, 'regulationInfo.judgementDate', {}) !== NONE
        ? get(rcCorpo, 'regulationInfo.judgementDate', {})
        : get(rcCorpo.regulationInfo, REGULATIONS.JUDGEMENT_DATE_JAF, null),
    );

    const assignedLawyers = removeDeletedAssignement(
      get(claimRecap, 'claim.assignment', []),
    )
      .map((item: any) =>
        item.judiciaryProcessId ===
        get(judgementOnMeritsByValue, 'judiciaryProcessId', '')
          ? get(item, 'assignedLawyer', '')
          : {},
      )
      .filter((item: any) => !isEmpty(item));
    if (risk.riskName === RISK_NAME.CORPOREAL) {
      !isEmpty(assignedLawyers) &&
        props.requestGetAssignedLawyers(assignedLawyers);
    }
  }, [
    claimRecap,
    get(rcCorpo.regulationInfo, REGULATIONS.PROCESS_NATURE),
    get(rcCorpo.regulationInfo, REGULATIONS.JUDGEMENT_DATE),
    get(rcCorpo.regulationInfo, REGULATIONS.COURT_NUMBER),
  ]);
  const { withAppeal, withFirstInstance } = !props.isBasicManagementRegulation
    ? hasAllProcedureTypes(judgementOnMerits, props.judgementOnMeritsWithCivjvm)
    : {
        withAppeal: get(risk.regulationInfo, [REGULATIONS.IS_APPEAL]),
        withFirstInstance: get(risk.regulationInfo, [REGULATIONS.IS_APPEAL]),
      };

  const handleChange = (risk: any, target?: any) => (
    event: React.ChangeEvent<{ name?: string; value: any }>,
    valueField?: any,
  ) => {
    const risks = [...props.riskRecap];
    const regulationInfo = get(
      risks[risks.indexOf(risk)],
      'regulationInfo',
      {},
    );

    if (!props.isBasicManagementRegulation) {
      switch (event.target.name) {
        case REGULATIONS.IS_IDD_CHECKED:
          regulationInfo[event.target.name] = event.target.value;
          regulationInfo[REGULATIONS.DEDUCTION_RATE] =
            regulationInfo[event.target.name] === IDD_CHECK.FALSE
              ? DEDUCTION_NO_RATE_IDD
              : DEDUCTION_RATE_IDD;
          break;
        case REGULATIONS.BENEFICIARY_RECIPIENT:
          regulationInfo[event.target.name] = event.target.value;
          setPaymentChannelByBeneficiaryRecipient(
            judiciaryChannel,
            regulationInfo,
            event.target.value,
          );
          beneficiaryRecipientCases(
            event.target.value,
            regulationInfo,
            get(listings, 'PaymentMethod', []),
            get(listings, 'appConfig', []),
            get(listings, 'EncryptDocumentCity', []),
          );
          break;
        case REGULATIONS.CITY_CODE:
          regulationInfo[event.target.name] = event.target.value;
          beneficiaryRecipientCases(
            get(regulationInfo, 'beneficiaryRecipient', ''),
            regulationInfo,
            get(listings, 'PaymentMethod', []),
            get(listings, 'appConfig', []),
            get(listings, 'EncryptDocumentCity', []),
          );
          break;
        case REGULATIONS.BNEJ_NUMBER:
          regulationInfo[REGULATIONS.BNEJ_NUMBER] = event.target.value;
          break;
        case REGULATIONS.DIRECT_INDEMNITY_COSTS:
          regulationInfo[event.target.name] = numberWithCommas(
            event.target.value,
          );
          break;
        case REGULATIONS.BNEJ_TAX_AMOUNT:
          regulationInfo[event.target.name] = numberWithCommas(
            event.target.value,
          );
          break;

        case REGULATIONS.JUDGEMENT_DATE_JAF:
          const judgementOnMeritsByValue = getJudgementOnMeritsByTargetValue(
            judgementOnMerits,
            event.target.value,
          );
          regulationInfo[event.target.name] = event.target.value;
          regulationInfo[REGULATIONS.JUDGEMENT_COURT_NUMBER] = get(
            judgementOnMeritsByValue,
            COURT_NUMBER,
            null,
          );
          break;
        default:
          if (event.target.name)
            regulationInfo[event.target.name] = event.target.value;
      }

      if (
        event.target.name === REGULATIONS.JUDGEMENT_DATE ||
        (event.target.name === REGULATIONS.JUDGEMENT_DATE_JAF &&
          regulationInfo[REGULATIONS.JUDGEMENT_DATE] === NONE) ||
        event.target.name === REGULATIONS.COURT_NUMBER
      ) {
        const judgementOnMeritsByValue = getJudgementOnMeritsByTargetValue(
          judgementOnMerits,
          event.target.value,
        );
        if (rcCorpo) {
          const substituteDocumentNature = getDocumentNature(
            get(listings, 'EncryptDocumentNature', []),
            judgementOnMeritsByValue,
            rcCorpo,
            sagisClaim,
            false,
            get(listings, 'PaymentStatus', []),
            props.isBasicManagementRegulation,
          );
          const totalJudgementNature = getCurrentRegulationNature(
            get(listings, 'EncryptDocumentNature', []),
            regulationInfo,
          );

          setSubstituteDocumentNature(substituteDocumentNature);

          if (!isEmpty(totalJudgementNature)) {
            const currentDocNature =
              substituteDocumentNature.find(
                (el: any) =>
                  el.ItemDescription ===
                  DOCUMENT_NATURE.TOTAL_JUDGEMENT.substitute,
              ) || {};
            regulationInfo[REGULATIONS.REGULATION_NATURE] = get(
              currentDocNature,
              'ItemKey',
              '',
            );
          }

          regulationInfo[REGULATIONS.CALCULATION_START_DATE] = get(
            judgementOnMeritsByValue,
            CALCULATION_START_DATE,
            null,
          );
          regulationInfo[REGULATIONS.JUDGEMENT_ID] = get(
            judgementOnMeritsByValue,
            JUDGEMENT_ID_JOM,
            null,
          );
          regulationInfo[REGULATIONS.IS_IDD_CHECKED] = get(
            judgementOnMeritsByValue,
            IDD,
            null,
          );
          regulationInfo[REGULATIONS.RC] = getSharedResponsibility(
            judgementOnMeritsByValue,
          );
          regulationInfo[REGULATIONS.DEDUCTION_RATE] =
            get(judgementOnMeritsByValue, IDD, null) === IDD_CHECK.FALSE
              ? DEDUCTION_NO_RATE_IDD
              : DEDUCTION_RATE_IDD;
          regulationInfo[REGULATIONS.OPPOSING_LAWYER] = !!get(
            judgementOnMeritsByValue,
            OPPOSING_LAWYER,
            '',
          )
            ? get(judgementOnMeritsByValue, OPPOSING_LAWYER, '')
            : get(regulationInfo, [REGULATIONS.OPPOSING_LAWYER], '');
        }
        if (rcCorpo || rcMaterial) {
          regulationInfo[
            REGULATIONS.VALIDATOR
          ] = currentUserStorage?.get()?.username?.toUpperCase();
          regulationInfo[REGULATIONS.STATUS] = get(
            judgementOnMeritsByValue,
            'status',
            '',
          );

          regulationInfo[REGULATIONS.WITH_CONTESTATION] = !isEmpty(
            get(judgementOnMeritsByValue, 'jom.jmc', {}),
          );
          regulationInfo[REGULATIONS.JUDGEMENT_DATE] = setJudgementDate(
            judgementOnMerits,
            judgementOnMeritsByValue,
            props.judgementOnMeritsWithCivjvm,
            event.target.name,
            event.target.value,
            regulationInfo[REGULATIONS.JUDGEMENT_DATE],
          );
          regulationInfo[REGULATIONS.JUDGEMENT_ID] = get(
            judgementOnMeritsByValue,
            JUDGEMENT_ID_JOM,
            null,
          );
          regulationInfo[
            REGULATIONS.ASSIGNED_LAWYER
          ] = removeDeletedAssignement(get(claimRecap, 'claim.assignment', []))
            .map((item: any) =>
              item.judiciaryProcessId ===
              get(judgementOnMeritsByValue, 'judiciaryProcessId', '')
                ? get(item, 'assignedLawyer', '')
                : {},
            )
            .filter((item: any) => !isEmpty(item));
          regulationInfo[REGULATIONS.JUDGEMENT_DATE_JAF] =
            withAppeal &&
            withFirstInstance &&
            !checkIsAppealProcess(judgementOnMeritsByValue) &&
            !!get(judgementOnMeritsByValue, JUDGEMENT_DATE, null)
              ? formatDate(get(judgementOnMeritsByValue, JUDGEMENT_DATE, null))
              : null;
          regulationInfo[REGULATIONS.JUDGEMENT_COURT_NUMBER] = !isEmpty(
            regulationInfo[REGULATIONS.JUDGEMENT_DATE_JAF],
          )
            ? get(judgementOnMeritsByValue, COURT_NUMBER, null)
            : '';
          regulationInfo[REGULATIONS.IS_APPEAL] =
            withAppeal &&
            withFirstInstance &&
            regulationInfo[REGULATIONS.JUDGEMENT_DATE] !== NONE
              ? true
              : withAppeal && !withFirstInstance
              ? true
              : false;
          regulationInfo[REGULATIONS.COURT_NUMBER] =
            regulationInfo[REGULATIONS.JUDGEMENT_DATE] === NONE ||
            isEmpty(regulationInfo[REGULATIONS.JUDGEMENT_DATE_JAF])
              ? get(judgementOnMeritsByValue, COURT_NUMBER, null)
              : '';
        }
      }
    } else {
      regulationInfo[
        REGULATIONS.VALIDATOR
      ] = currentUserStorage?.get()?.username?.toUpperCase();
      switch (event.target.name) {
        case REGULATIONS.JUDGEMENT_DATE:
          regulationInfo[REGULATIONS.JUDGEMENT_DATE] = moment(
            event.target.value,
          ).format(DATE_FORMAT);
          break;
        case REGULATIONS.JUDGEMENT_DATE_JAF:
          regulationInfo[REGULATIONS.JUDGEMENT_DATE_JAF] = moment(
            event.target.value,
          ).format(DATE_FORMAT);
          break;
        case REGULATIONS.ASSIGNED_LAWYER_BASIC_MANAGEMENT:
          regulationInfo[REGULATIONS.ASSIGNED_LAWYER_BASIC_MANAGEMENT] =
            event.target.value;
          regulationInfo[
            REGULATIONS.ASSIGNED_LAWYER
          ] = removeDeletedAssignement(get(claimRecap, 'claim.assignment', []))
            .filter(
              (item: any) =>
                String(item.assignedLawyer) === String(event.target.value),
            )
            .map((el: any) => el.assignedLawyer);
          break;
        case REGULATIONS.PROCEDURE_TYPE:
          regulationInfo[REGULATIONS.IS_APPEAL] =
            event.target.value === PROCEDURE_TYPES.APPEAL;
          regulationInfo[REGULATIONS.PROCEDURE_TYPE] = event.target.value;
          regulationInfo[REGULATIONS.PROCESS_NATURE] =
            PROCESS_NATURE_MAPPER.CORRECTIONNELLE;
          break;
        case REGULATIONS.IS_IDD_CHECKED:
          regulationInfo[event.target.name] = event.target.value;
          regulationInfo[REGULATIONS.DEDUCTION_RATE] =
            regulationInfo[event.target.name] === IDD_CHECK.FALSE
              ? DEDUCTION_NO_RATE_IDD
              : DEDUCTION_RATE_IDD;
          break;
        case REGULATIONS.SHARED_RESPONSABILITY_RATE_WIHTOUT_JUDGEMENT:
          regulationInfo[event.target.name] = parseFloat(event.target.value);
          regulationInfo[REGULATIONS.RC] = parseFloat(event.target.value);
          break;
        case REGULATIONS.BENEFICIARY_RECIPIENT:
          regulationInfo[event.target.name] = event.target.value;
          setPaymentChannelByBeneficiaryRecipient(
            judiciaryChannel,
            regulationInfo,
            event.target.value,
          );
          beneficiaryRecipientCases(
            event.target.value,
            regulationInfo,
            get(listings, 'PaymentMethod', []),
            get(listings, 'appConfig', []),
            get(listings, 'EncryptDocumentCity', []),
          );
          break;
        case REGULATIONS.DIRECT_INDEMNITY_COSTS:
          regulationInfo[event.target.name] = numberWithCommas(
            event.target.value,
          );
          break;
        case REGULATIONS.BNEJ_TAX_AMOUNT:
          regulationInfo[event.target.name] = numberWithCommas(
            event.target.value,
          );
          break;
        case REGULATIONS.CITY_CODE:
          regulationInfo[event.target.name] = event.target.value;
          beneficiaryRecipientCases(
            get(regulationInfo, 'beneficiaryRecipient', ''),
            regulationInfo,
            get(listings, 'PaymentMethod', []),
            get(listings, 'appConfig', []),
            get(listings, 'EncryptDocumentCity', []),
          );
          break;
        case REGULATIONS.BNEJ_NUMBER:
          regulationInfo[REGULATIONS.BNEJ_NUMBER] = event.target.value;
          break;
        default:
          if (event.target.name)
            regulationInfo[event.target.name] = event.target.value;
      }
      if (rcCorpo) {
        const substituteDocumentNature = getDocumentNature(
          get(listings, 'EncryptDocumentNature', []),
          {},
          rcCorpo,
          sagisClaim,
          false,
          get(listings, 'PaymentStatus', []),
          props.isBasicManagementRegulation,
        );
        const totalJudgementNature = getCurrentRegulationNature(
          get(listings, 'EncryptDocumentNature', []),
          regulationInfo,
        );

        setSubstituteDocumentNature(substituteDocumentNature);
        if (!isEmpty(totalJudgementNature)) {
          const currentDocNature =
            substituteDocumentNature.find(
              (el: any) =>
                el.ItemDescription ===
                DOCUMENT_NATURE.TOTAL_JUDGEMENT.substitute,
            ) || {};
          regulationInfo[REGULATIONS.REGULATION_NATURE] = get(
            currentDocNature,
            'ItemKey',
            '',
          );
        }
      }
    }

    if (event.target.name === REGULATIONS.PROCESS_NATURE) {
      risk.riskName === RISK_NAME.CORPOREAL &&
        requestGetJudgementOnMerits(
          get(claimRecap, 'claim.id'),
          get(rcCorpo, 'data', []).map((rcCorpo: any) => rcCorpo.id),
          getCheckedBeneficiaries(rcCorpo),
          event.target.value,
        );
      risk.riskName === RISK_NAME.MATERIEL &&
        requestGetJudgementOnMerits(
          get(claimRecap, 'claim.id'),
          get(risk, 'data', []).map((rc: any) => rc.id),
          regulationInfo.processNature,
          null,
        );
    }
    if (get(valueField, 'ItemType') === 'Town' && !!target) {
      regulationInfo[target] = get(valueField, 'ItemKey', '');
    }
    props.setRiskRecap(risks);
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: SagisConfig) => option?.ItemDescription,
  });

  useEffect(() => {
    getUpdatedJudgementOnMerits(
      props.riskRecap,
      requestGetJudgementOnMerits,
      claimRecap,
      risk,
    );
  }, [riskData?.victims, riskData?.vehicles]);
  const handleChangeRegulationDate = (risk: any, date: Date | null) => {
    const risks = [...props.riskRecap];
    const currentRisk =
      risks.find(item => item.riskName === risk.riskName) || {};
    const regulationInfo = get(
      risks[risks.indexOf(currentRisk)],
      'regulationInfo',
      {},
    );
    const theDate = getDateIgnoreTimezone(date);
    const regulationDate = moment(theDate as Date).format(DATE_FORMAT);
    regulationInfo[REGULATIONS.REGULATION_DATE] = regulationDate;
    return props.setRiskRecap(risks);
  };
  const handleChangeIDDDate = (risk: any, date: Date | null) => {
    const risks = [...props.riskRecap];
    const currentRisk =
      risks.find(item => item.riskName === risk.riskName) || {};

    const regulationInfo = get(
      risks[risks.indexOf(currentRisk)],
      'regulationInfo',
      {},
    );
    const theDate = getDateIgnoreTimezone(date);
    const calculationStartDate = moment(theDate as Date).format(DATE_FORMAT);
    regulationInfo[REGULATIONS.CALCULATION_START_DATE] = calculationStartDate;
    return props.setRiskRecap(risks);
  };
  const handleChangeExpanded = (event: React.ChangeEvent<{}>, item: any) => {
    const types = [...props.riskRecap] as any;
    const currentType =
      types.find((type: any) => type.riskName === item.riskName) || {};

    if (!isEmpty(currentType)) {
      const index = types.indexOf(currentType);

      types[index].regulationInfo.expand = !get(
        item,
        'regulationInfo.expand',
        false,
      );
      return props.setRiskRecap(types);
    }
  };
  const linkWithRecipient = getLinkWithRecepient(
    get(listings, 'LinesOfRecipt', []),
  );
  const countries: SagisConfig[] = getCountriesWithCities(
    get(listings, 'country', []),
    get(listings, 'villes', []),
  );
  const country =
    countries.find(
      (country: SagisConfig) => country.ItemDescription === MOROCCO_COUNTRY,
    ) || {};
  const isFraudRecipient = useMemo(
    () =>
      getRegulationRecipient(risk, get(listings, 'regulationRecipient', [])),
    [risk],
  );

  return (
    <StyledDiv key={risk.regulationId}>
      {!isEmpty(get(risk, 'data', [])) && (
        <SahamAccordion
          key={risk.regulationId}
          title={`${translate(messages.riskInfo, props)} - ${risk.riskName}`}
          expanded={get(risk, 'regulationInfo.expand', false)}
          onChange={_ => handleChangeExpanded(_, risk)}
        >
          <>
            <Grid container spacing={4} className="regulation-info">
              {props.isBasicManagementRegulation && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="is-appeal-label">
                      {translate(messages.processType, props)}
                    </InputLabel>
                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.PROCEDURE_TYPE}
                      name={REGULATIONS.PROCEDURE_TYPE}
                      id={REGULATIONS.PROCEDURE_TYPE}
                      value={get(risk.regulationInfo, 'procedureType', '')}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.PROCEDURE_TYPE],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    >
                      {REGULATION_JUDGEMENT_PROCEDURE_TYPE.map(option => (
                        <MenuItem key={option.key} value={option.key}>
                          {option.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {!props.isBasicManagementRegulation && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="idd-label-id">
                      {translate(messages.processNature, props)}
                    </InputLabel>
                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.PROCESS_NATURE}
                      name={REGULATIONS.PROCESS_NATURE}
                      id={REGULATIONS.PROCESS_NATURE}
                      value={get(risk, 'regulationInfo.processNature', '')}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.PROCESS_NATURE],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    >
                      {formatProcedureNatureIds(
                        get(listings, 'procedureNature', []) as any,
                        props.judgementNatureProcedureIds,
                      ).map((el: Config) => (
                        <MenuItem
                          data-testid={el.title}
                          id={el.title}
                          key={el.id}
                          value={el.id}
                        >
                          {el.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {props.isBasicManagementRegulation ? (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      label={translate({ ...messages.courtNumber }, props)}
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.COURT_NUMBER}
                      name={REGULATIONS.COURT_NUMBER}
                      id={REGULATIONS.COURT_NUMBER}
                      defaultValue={get(risk, 'regulationInfo.courtNumber', '')}
                      value={get(risk, 'regulationInfo.courtNumber', '')}
                      error={
                        (get(
                          messageError[risk.regulationId],
                          [REGULATIONS.COURT_NUMBER],
                          '',
                        ) &&
                          isStepValidated[activeStep]) ||
                        !validationCourtFileNumber(
                          get(risk, 'regulationInfo.courtNumber', ''),
                        )
                      }
                    />
                  </FormControl>
                </Grid>
              ) : (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel
                      id="court-number"
                      shrink={
                        isEmpty(get(risk, 'regulationInfo.courtNumber', ''))
                          ? false
                          : true
                      }
                    >
                      {translate({ ...messages.courtNumber }, props)}
                    </InputLabel>
                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.COURT_NUMBER}
                      name={REGULATIONS.COURT_NUMBER}
                      id={REGULATIONS.COURT_NUMBER}
                      value={get(risk, 'regulationInfo.courtNumber', '')}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.COURT_NUMBER],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    >
                      {judgementOnMerits.map((el: Config) => (
                        <MenuItem
                          key={get(el, 'jom.id')}
                          value={get(el, COURT_NUMBER, '')}
                        >
                          {get(el, COURT_NUMBER, '')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {props.isBasicManagementRegulation &&
                featureService.hasFeature(FEATURES.EVOLUTION_P3) && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="idd-label-id">
                        {translate(messages.assignedLawyerTitle, props)}
                      </InputLabel>
                      <Select
                        onChange={handleChange(risk)}
                        data-testid={
                          REGULATIONS.ASSIGNED_LAWYER_BASIC_MANAGEMENT
                        }
                        name={REGULATIONS.ASSIGNED_LAWYER_BASIC_MANAGEMENT}
                        id={REGULATIONS.ASSIGNED_LAWYER_BASIC_MANAGEMENT}
                        value={get(
                          risk,
                          'regulationInfo.assignedLawyerBasicManagement',
                          '',
                        )}
                        error={
                          get(
                            messageError[risk.regulationId],
                            [REGULATIONS.ASSIGNED_LAWYER_BASIC_MANAGEMENT],
                            '',
                          ) && isStepValidated[activeStep]
                        }
                      >
                        {removeDeletedAssignement(
                          get(claimRecap, 'claim.assignment', []),
                        ).map((el: any) => (
                          <MenuItem
                            data-testid={el.assignedLawyer}
                            id={el.assignedLawyer}
                            key={el.assignedLawyer}
                            value={el.assignedLawyer}
                          >
                            {getValueByCode(
                              el.assignedLawyer,
                              get(listings, LISTINGS.STACKHOLDERS, []),
                            )}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              {risk.riskName === RISK_NAME.CORPOREAL && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>
                      {translate(messages.regulationNature, props)}
                    </InputLabel>

                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.REGULATION_NATURE}
                      name={REGULATIONS.REGULATION_NATURE}
                      id={REGULATIONS.REGULATION_NATURE}
                      value={get(risk, 'regulationInfo.natureCode', '')}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.REGULATION_NATURE],
                          '',
                        ) &&
                        isStepValidated[activeStep] &&
                        risk.riskName === RISK_NAME.CORPOREAL
                      }
                    >
                      {substituteDocumentNature.map((el: SagisConfig) => (
                        <MenuItem key={el.ItemKey} value={el.ItemKey}>
                          {get(el, 'ItemDescription', '')}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel>
                    {translate(messages.regulationPhase, props)}
                  </InputLabel>

                  <Select
                    onChange={handleChange(risk)}
                    data-testid={REGULATIONS.PAYMENT_NATURE}
                    name={REGULATIONS.PAYMENT_NATURE}
                    id={REGULATIONS.PAYMENT_NATURE}
                    value={get(risk, 'regulationInfo.PaymentNatureCode', '')}
                    error={
                      get(
                        messageError[risk.regulationId],
                        [REGULATIONS.PAYMENT_NATURE],
                        '',
                      ) && isStepValidated[activeStep]
                    }
                  >
                    {[
                      getPaymentNature(
                        get(listings, 'PaymentNature', []),
                      ) as any,
                    ].map((el: SagisConfig) => (
                      <MenuItem
                        data-testid={el.ItemKey}
                        id={el.ItemKey}
                        key={el.ItemKey}
                        value={el.ItemKey}
                      >
                        {el.ItemDescription}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel id="idd-label-id">
                    {translate(messages.recipient, props)}
                  </InputLabel>
                  <Select
                    onChange={handleChange(risk)}
                    data-testid={REGULATIONS.BENEFICIARY_RECIPIENT}
                    name={REGULATIONS.BENEFICIARY_RECIPIENT}
                    id={REGULATIONS.BENEFICIARY_RECIPIENT}
                    value={get(risk, 'regulationInfo.beneficiaryRecipient', '')}
                    error={
                      get(
                        messageError[risk.regulationId],
                        [REGULATIONS.BENEFICIARY_RECIPIENT],
                        '',
                      ) && isStepValidated[activeStep]
                    }
                  >
                    {isFraudRecipient.map((el: Config) => (
                      <MenuItem
                        data-testid={el.title}
                        key={el.id}
                        value={el.title}
                      >
                        {el.title}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText style={{ color: 'red', height: 0 }}>
                    {getRecipientWhenFraud(risk) &&
                    risk.riskName === RISK_NAME.CORPOREAL
                      ? translate(messages.regulationVictimFraud, props)
                      : getRecipientWhenFraud(risk) &&
                        risk.riskName === RISK_NAME.MATERIEL &&
                        translate(messages.regulationVehicleFraud, props)}
                  </FormHelperText>
                </FormControl>
              </Grid>
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                RECIPIENT.BNEJ && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="idd-label-id">
                      {translate(messages.bnejCity, props)}
                    </InputLabel>
                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.CITY_CODE}
                      name={REGULATIONS.CITY_CODE}
                      id={REGULATIONS.CITY_CODE}
                      value={get(
                        risk.regulationInfo,
                        [REGULATIONS.CITY_CODE],
                        '',
                      )}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.CITY_CODE],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    >
                      {get(listings, 'EncryptDocumentCity', []).map(
                        (el: SagisConfig) => (
                          <MenuItem
                            data-testid={el.ItemDescription}
                            key={el.ItemKey}
                            value={el.ItemKey}
                          >
                            {el.ItemDescription}
                          </MenuItem>
                        ),
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                RECIPIENT.BNEJ && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      label={translate(messages.bnejNumberTitle, props)}
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.BNEJ_NUMBER}
                      name={REGULATIONS.BNEJ_NUMBER}
                      id={REGULATIONS.BNEJ_NUMBER}
                      defaultValue={get(risk, 'regulationInfo.BNEJNumber', '')}
                      value={get(risk, 'regulationInfo.BNEJNumber', '')}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.BNEJ_NUMBER],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                      helperText={
                        isStepValidated[activeStep] &&
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.BNEJ_NUMBER],
                          null,
                        )
                      }
                    />
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel>
                    {translate(messages.paymentMethod, props)}
                  </InputLabel>

                  <Select
                    onChange={handleChange(risk)}
                    data-testid={REGULATIONS.PAYMENT_METHOD}
                    name={REGULATIONS.PAYMENT_METHOD}
                    id={REGULATIONS.PAYMENT_METHOD}
                    value={get(
                      risk.regulationInfo,
                      REGULATIONS.PAYMENT_METHOD,
                      '',
                    )}
                    disabled={
                      get(
                        risk.regulationInfo,
                        REGULATIONS.BENEFICIARY_RECIPIENT,
                      ) === RECIPIENT.BNEJ
                    }
                    error={
                      get(
                        messageError[risk.regulationId],
                        [REGULATIONS.PAYMENT_METHOD],
                        '',
                      ) && isStepValidated[activeStep]
                    }
                  >
                    {paymentMethod(get(listings, 'PaymentMethod', [])).map(
                      (el: SagisConfig) => (
                        <MenuItem
                          data-testid={el.ItemKey}
                          id={el.ItemKey}
                          key={el.ItemKey}
                          value={el.ItemKey}
                        >
                          {el.ItemDescription}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </FormControl>
              </Grid>
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                RECIPIENT.CDRA && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="idd-label-id">
                      {translate(messages.cdraRealBeneficiary, props)}
                    </InputLabel>
                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.REAL_BENEFICIARY}
                      name={REGULATIONS.REAL_BENEFICIARY}
                      id={REGULATIONS.REAL_BENEFICIARY}
                      value={get(risk, 'regulationInfo.realBeneficiary', '')}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.REAL_BENEFICIARY],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    >
                      {get(listings, 'bar', []).map((el: Config) => (
                        <MenuItem
                          data-testid={el.title}
                          key={el.id}
                          value={el.title}
                        >
                          {el.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                RECIPIENT.BNEJ && (
                <>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        label={translate(messages.realBeneficiary, props)}
                        onChange={handleChange(risk)}
                        data-testid={REGULATIONS.REAL_BENEFICIARY}
                        name={REGULATIONS.REAL_BENEFICIARY}
                        value={get(risk, 'regulationInfo.realBeneficiary', '')}
                        error={
                          get(
                            messageError[risk.regulationId],
                            [REGULATIONS.REAL_BENEFICIARY],
                            '',
                          ) && isStepValidated[activeStep]
                        }
                        disabled={true}
                      />
                    </FormControl>
                  </Grid>
                </>
              )}

              {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                RECIPIENT.OTHERS && (
                <Grid item xs={4} className="other-item">
                  <TextField
                    fullWidth
                    onChange={handleChange(risk)}
                    data-testid={REGULATIONS.OTHER_RECIPIENT}
                    name={REGULATIONS.OTHER_RECIPIENT}
                    value={get(risk, 'regulationInfo.otherRecipient', '')}
                  />
                </Grid>
              )}
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                RECIPIENT.OTHERS && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>
                      {translate(messages.paymentChannel, props)}
                    </InputLabel>

                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.PAYMENT_CHANNEL}
                      name={REGULATIONS.PAYMENT_CHANNEL}
                      id={REGULATIONS.PAYMENT_CHANNEL}
                      value={get(
                        risk.regulationInfo,
                        REGULATIONS.PAYMENT_CHANNEL,
                        '',
                      )}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.PAYMENT_CHANNEL],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    >
                      {judiciaryChannel.map((el: SagisConfig) => (
                        <MenuItem
                          data-testid={el.ItemKey}
                          id={el.ItemKey}
                          key={el.ItemKey}
                          value={el.ItemKey}
                        >
                          {el.ItemDescription}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                RECIPIENT.OTHERS && (
                <>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="idd-label-id">
                        {translate(messages.realBeneficiary, props)}
                      </InputLabel>
                      <Select
                        onChange={handleChange(risk)}
                        data-testid={REGULATIONS.REAL_BENEFICIARY}
                        name={REGULATIONS.REAL_BENEFICIARY}
                        id={REGULATIONS.REAL_BENEFICIARY}
                        value={get(risk, 'regulationInfo.realBeneficiary', '')}
                        error={
                          get(
                            messageError[risk.regulationId],
                            [REGULATIONS.REAL_BENEFICIARY],
                            '',
                          ) && isStepValidated[activeStep]
                        }
                      >
                        {linkWithRecipient.map((el: SagisConfig) => (
                          <MenuItem
                            data-testid={el.ItemDescription}
                            key={el.ItemKey}
                            value={el.ItemDescription}
                          >
                            {el.ItemDescription}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {get(risk, 'regulationInfo.realBeneficiary', '') ===
                    RECIPIENT.OTHERS && (
                    <Grid item xs={4} className="other-item">
                      <TextField
                        fullWidth
                        onChange={handleChange(risk)}
                        data-testid={REGULATIONS.OTHER_REAL_BENEFICIARY}
                        name={REGULATIONS.OTHER_REAL_BENEFICIARY}
                        value={get(
                          risk,
                          'regulationInfo.otherRealBeneficiary',
                          '',
                        )}
                      />
                    </Grid>
                  )}
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label={translate(messages.additionalAddress, props)}
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.ADDITIONAL_ADDRESS}
                      name={REGULATIONS.ADDITIONAL_ADDRESS}
                      value={get(risk, 'regulationInfo.complement', '')}
                    />
                  </Grid>
                </>
              )}
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') !==
                RECIPIENT.OTHERS && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      label={translate(messages.additionalAddress, props)}
                      onChange={handleChange(risk)}
                      name={REGULATIONS.ADDITIONAL_ADDRESS}
                      defaultValue={get(
                        risk,
                        'regulationInfo.realBeneficiary',
                        '',
                      )}
                      value={get(risk, 'regulationInfo.realBeneficiary', '')}
                      disabled={true}
                    />
                  </FormControl>
                </Grid>
              )}
              {risk.riskName !== RISK_NAME.CORPOREAL && (
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel id="idd-label-id">
                      {translate(messages.linkToBeneficiary, props)}
                    </InputLabel>
                    <Select
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.LINK_TO_BENEFICIARY}
                      name={REGULATIONS.LINK_TO_BENEFICIARY}
                      id={REGULATIONS.LINK_TO_BENEFICIARY}
                      value={get(
                        risk.regulationInfo,
                        [REGULATIONS.LINK_TO_BENEFICIARY],
                        '',
                      )}
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.LINK_TO_BENEFICIARY],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    >
                      {getLinkWithRecepientForMaterialRisk(
                        get(listings, 'LinesOfRecipt', []),
                      ).map((el: SagisConfig) => (
                        <MenuItem
                          data-testid={el.ItemDescription}
                          key={el.ItemDescription}
                          value={el.ItemDescription}
                        >
                          {el.ItemDescription}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    label={translate(messages.beneficiaryReference, props)}
                    onChange={handleChange(risk)}
                    data-testid={REGULATIONS.BENEFICIARY_REFERENCE}
                    name={REGULATIONS.BENEFICIARY_REFERENCE}
                    value={get(risk, 'regulationInfo.beneficiaryReference', '')}
                    error={
                      get(
                        messageError[risk.regulationId],
                        [REGULATIONS.BENEFICIARY_REFERENCE],
                        '',
                      ) && isStepValidated[activeStep]
                    }
                    helperText={messageError[REGULATIONS.BENEFICIARY_REFERENCE]}
                  />
                </FormControl>
              </Grid>
              {get(risk, 'regulationInfo.beneficiaryRecipient', '') !==
                RECIPIENT.CDRA && (
                <>
                  <Grid item xs={4}>
                    <Autocomplete
                      options={getCities(
                        get(listings, 'villes', []),
                        get(country, 'ItemKey'),
                      )}
                      value={getChosenCity(
                        get(listings, 'villes', []),
                        risk,
                        REGULATIONS.TOWN_CODE,
                      )}
                      id={REGULATIONS.TOWN_CODE}
                      defaultValue={getChosenCity(
                        get(listings, 'villes', []),
                        risk,
                        REGULATIONS.TOWN_CODE,
                      )}
                      getOptionLabel={(city: SagisConfig) =>
                        city.ItemDescription
                      }
                      autoSelect={true}
                      onChange={
                        handleChange(risk, REGULATIONS.TOWN_CODE) as any
                      }
                      filterOptions={filterOptions}
                      renderInput={params => (
                        <TextField
                          {...params}
                          name={REGULATIONS.TOWN_CODE}
                          label={translate({ ...messages.town }, props)}
                          error={
                            get(
                              messageError[risk.regulationId],
                              [REGULATIONS.TOWN_CODE],
                              '',
                            ) && isStepValidated[activeStep]
                          }
                          helperText={messageError[REGULATIONS.TOWN_CODE]}
                        />
                      )}
                      fullWidth
                    />
                  </Grid>
                </>
              )}

              {risk.riskName === RISK_NAME.CORPOREAL &&
                props.isBasicManagementRegulation && (
                  <Grid item xs={4}>
                    <TextField
                      name={
                        REGULATIONS.SHARED_RESPONSABILITY_RATE_WIHTOUT_JUDGEMENT
                      }
                      data-testId="shared-responsability"
                      label={translate(messages.responsabilityShare, props)}
                      value={get(
                        risk,
                        'regulationInfo.sharedResponsabilityRate',
                        null,
                      )}
                      style={{ width: '100%' }}
                      onChange={handleChange(risk)}
                      InputProps={{
                        inputProps: {
                          min: 0,
                        },
                        endAdornment: (
                          <InputAdornment position="end">{'%'}</InputAdornment>
                        ),
                      }}
                      type="number"
                      error={
                        get(risk, 'regulationInfo.sharedResponsabilityRate') >
                        100
                      }
                      helperText={
                        get(risk, 'regulationInfo.sharedResponsabilityRate') >
                          100 &&
                        translate(messages.validateRequiredField, props)
                      }
                    />
                  </Grid>
                )}
              {risk.riskName === RISK_NAME.CORPOREAL && (
                <>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label={translate(messages.opposingLawyer, props)}
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.OPPOSING_LAWYER}
                      name={REGULATIONS.OPPOSING_LAWYER}
                      value={get(
                        risk.regulationInfo,
                        REGULATIONS.OPPOSING_LAWYER,
                        '',
                      )}
                      helperText={
                        get(messageError[risk.regulationId], [
                          REGULATIONS.OPPOSING_LAWYER,
                        ]) && isStepValidated[activeStep]
                      }
                      error={
                        get(
                          messageError[risk.regulationId],
                          [REGULATIONS.OPPOSING_LAWYER],
                          '',
                        ) && isStepValidated[activeStep]
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Autocomplete
                      options={getCities(
                        get(listings, 'villes', []),
                        get(country, 'ItemKey'),
                      )}
                      value={getChosenCity(
                        get(listings, 'villes', []),
                        risk,
                        REGULATIONS.OPPOSING_LAWYER_CITY,
                      )}
                      id={REGULATIONS.OPPOSING_LAWYER_CITY}
                      defaultValue={getChosenCity(
                        get(listings, 'villes', []),
                        risk,
                        REGULATIONS.OPPOSING_LAWYER_CITY,
                      )}
                      getOptionLabel={(city: SagisConfig) =>
                        city.ItemDescription
                      }
                      autoSelect={true}
                      onChange={
                        handleChange(
                          risk,
                          REGULATIONS.OPPOSING_LAWYER_CITY,
                        ) as any
                      }
                      filterOptions={filterOptions}
                      renderInput={params => (
                        <TextField
                          {...params}
                          name={REGULATIONS.OPPOSING_LAWYER_CITY}
                          label={translate(
                            { ...messages.opposingLawyerCity },
                            props,
                          )}
                          error={
                            get(
                              messageError[risk.regulationId],
                              [REGULATIONS.OPPOSING_LAWYER_CITY],
                              '',
                            ) && isStepValidated[activeStep]
                          }
                          helperText={
                            messageError[REGULATIONS.OPPOSING_LAWYER_CITY]
                          }
                        />
                      )}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label={translate(messages.opposingLawyerAddress, props)}
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.OPPOSING_LAWYER_ADDRESS}
                      name={REGULATIONS.OPPOSING_LAWYER_ADDRESS}
                      value={get(
                        risk.regulationInfo,
                        REGULATIONS.OPPOSING_LAWYER_ADDRESS,
                        '',
                      )}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label={translate(messages.opposingLawyerEmail, props)}
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.OPPOSING_LAWYER_EMAIL}
                      name={REGULATIONS.OPPOSING_LAWYER_EMAIL}
                      value={get(
                        risk.regulationInfo,
                        REGULATIONS.OPPOSING_LAWYER_EMAIL,
                        '',
                      )}
                      helperText={get(messageError[risk.regulationId], [
                        REGULATIONS.OPPOSING_LAWYER_EMAIL,
                      ])}
                      error={get(messageError[risk.regulationId], [
                        REGULATIONS.OPPOSING_LAWYER_EMAIL,
                      ])}
                    />
                  </Grid>
                </>
              )}
              {!(withAppeal && withFirstInstance) && (
                <Grid item xs={4}>
                  {/* Date de jugement */}
                  <FormControl fullWidth>
                    {props.isBasicManagementRegulation ? (
                      <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        locale={frLocale}
                      >
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          format={DATE_PICKET_FORMAT}
                          value={dateStringToLocalDate(
                            get(
                              risk.regulationInfo,
                              REGULATIONS.JUDGEMENT_DATE,
                              '',
                            ) as any,
                          )}
                          InputLabelProps={{
                            shrink: isEmpty(
                              get(risk, 'regulationInfo.judgementDate', ''),
                            )
                              ? false
                              : true,
                          }}
                          data-testid={REGULATIONS.JUDGEMENT_DATE}
                          onChange={date =>
                            handleChange(risk)({
                              target: {
                                name: REGULATIONS.JUDGEMENT_DATE,
                                value: date,
                              },
                            } as React.ChangeEvent<{
                              name?: string;
                              value: any;
                            }>)
                          }
                          label={
                            get(
                              risk.regulationInfo,
                              [REGULATIONS.IS_APPEAL],
                              '',
                            )
                              ? translate({ ...messages.appealDate }, props)
                              : translate({ ...messages.judgementDate }, props)
                          }
                          id="judgement-date"
                          error={
                            get(
                              messageError[risk.regulationId],
                              [REGULATIONS.JUDGEMENT_DATE],
                              '',
                            ) && isStepValidated[activeStep]
                          }
                          helperText={
                            isStepValidated[activeStep] &&
                            get(
                              messageError[risk.regulationId],
                              [REGULATIONS.JUDGEMENT_DATE],
                              null,
                            )
                          }
                        />
                      </MuiPickersUtilsProvider>
                    ) : (
                      <>
                        <InputLabel
                          id="judgement-date"
                          shrink={
                            isEmpty(
                              get(risk, 'regulationInfo.judgementDate', ''),
                            )
                              ? false
                              : true
                          }
                        >
                          {get(risk.regulationInfo, [REGULATIONS.IS_APPEAL], '')
                            ? translate({ ...messages.appealDate }, props)
                            : translate({ ...messages.judgementDate }, props)}
                        </InputLabel>
                        <Select
                          onChange={handleChange(risk)}
                          data-testid={REGULATIONS.JUDGEMENT_DATE}
                          name={REGULATIONS.JUDGEMENT_DATE}
                          id={REGULATIONS.JUDGEMENT_DATE}
                          value={get(risk, 'regulationInfo.judgementDate', '')}
                          error={
                            get(
                              messageError[risk.regulationId],
                              [REGULATIONS.JUDGEMENT_DATE],
                              '',
                            ) && isStepValidated[activeStep]
                          }
                        >
                          {judgementOnMerits.map((el: Config) => {
                            return (
                              <MenuItem
                                key={get(el, 'jom.id')}
                                value={formatDate(get(el, JUDGEMENT_DATE, ''))}
                              >
                                {formatDate(get(el, JUDGEMENT_DATE, ''))}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </>
                    )}
                  </FormControl>
                </Grid>
              )}
              {withAppeal && withFirstInstance && (
                <>
                  <Grid item xs={4}>
                    {/* Date d'arret */}
                    <FormControl fullWidth>
                      {props.isBasicManagementRegulation ? (
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={frLocale}
                        >
                          <KeyboardDatePicker
                            autoOk
                            variant="inline"
                            format={DATE_PICKET_FORMAT}
                            value={dateStringToLocalDate(
                              get(
                                risk,
                                'regulationInfo.judgementDate',
                                '',
                              ) as any,
                            )}
                            InputLabelProps={{
                              shrink: isEmpty(
                                get(risk, 'regulationInfo.judgementDate', ''),
                              )
                                ? false
                                : true,
                            }}
                            data-testid={REGULATIONS.JUDGEMENT_DATE}
                            onChange={date =>
                              handleChange(risk)({
                                target: {
                                  name: REGULATIONS.JUDGEMENT_DATE,
                                  value: date,
                                },
                              } as any)
                            }
                            label={translate({ ...messages.appealDate }, props)}
                            id="judgement-date"
                            error={
                              get(
                                messageError[risk.regulationId],
                                [REGULATIONS.JUDGEMENT_DATE],
                                '',
                              ) && isStepValidated[activeStep]
                            }
                            helperText={
                              isStepValidated[activeStep] &&
                              get(
                                messageError[risk.regulationId],
                                [REGULATIONS.JUDGEMENT_DATE],
                                null,
                              )
                            }
                          />
                        </MuiPickersUtilsProvider>
                      ) : (
                        <>
                          <InputLabel
                            id="judgement-date"
                            shrink={
                              isEmpty(
                                get(risk, 'regulationInfo.judgementDate', ''),
                              )
                                ? false
                                : true
                            }
                          >
                            {translate({ ...messages.appealDate }, props)}
                          </InputLabel>
                          <Select
                            onChange={handleChange(risk)}
                            data-testid={REGULATIONS.JUDGEMENT_DATE}
                            name={REGULATIONS.JUDGEMENT_DATE}
                            id={REGULATIONS.JUDGEMENT_DATE}
                            value={get(
                              risk,
                              'regulationInfo.judgementDate',
                              '',
                            )}
                            error={
                              get(
                                messageError[risk.regulationId],
                                [REGULATIONS.JUDGEMENT_DATE],
                                '',
                              ) && isStepValidated[activeStep]
                            }
                          >
                            {getAppealDates(judgementOnMerits).map(
                              (el: any) => (
                                <MenuItem key={el.id} value={el.value}>
                                  {el.value}
                                </MenuItem>
                              ),
                            )}
                          </Select>
                        </>
                      )}
                    </FormControl>
                  </Grid>

                  {withAppeal && (
                    <>
                      {props.isBasicManagementRegulation ? (
                        <Grid item xs={4}>
                          {/* Date de jugement Appel */}
                          <FormControl fullWidth>
                            <MuiPickersUtilsProvider
                              utils={DateFnsUtils}
                              locale={frLocale}
                            >
                              <KeyboardDatePicker
                                autoOk
                                variant="inline"
                                format={DATE_PICKET_FORMAT}
                                value={dateStringToLocalDate(
                                  get(
                                    risk,
                                    'regulationInfo.judgementDateJom',
                                    '',
                                  ) as any,
                                )}
                                InputLabelProps={{
                                  shrink: isEmpty(
                                    get(
                                      risk.regulationInfo,
                                      [REGULATIONS.JUDGEMENT_DATE_JAF],
                                      '',
                                    ),
                                  )
                                    ? false
                                    : true,
                                }}
                                data-testid={REGULATIONS.JUDGEMENT_DATE_JAF}
                                onChange={date =>
                                  handleChange(risk)({
                                    target: {
                                      name: REGULATIONS.JUDGEMENT_DATE_JAF,
                                      value: date,
                                    },
                                  } as any)
                                }
                                label={translate(
                                  { ...messages.judgementDate },
                                  props,
                                )}
                                id="judgement-date-jaf"
                                error={
                                  get(
                                    messageError[risk.regulationId],
                                    [REGULATIONS.JUDGEMENT_DATE_JAF],
                                    '',
                                  ) && isStepValidated[activeStep]
                                }
                                helperText={
                                  isStepValidated[activeStep] &&
                                  get(
                                    messageError[risk.regulationId],
                                    [REGULATIONS.JUDGEMENT_DATE_JAF],
                                    null,
                                  )
                                }
                              />
                            </MuiPickersUtilsProvider>
                          </FormControl>
                        </Grid>
                      ) : (
                        <Grid item xs={4}>
                          <FormControl fullWidth>
                            <InputLabel
                              id="judgement-date"
                              shrink={
                                isEmpty(
                                  get(
                                    risk.regulationInfo,
                                    [REGULATIONS.JUDGEMENT_DATE_JAF],
                                    '',
                                  ),
                                )
                                  ? false
                                  : true
                              }
                            >
                              {translate({ ...messages.judgementDate }, props)}
                            </InputLabel>
                            <Select
                              onChange={handleChange(risk)}
                              data-testid={REGULATIONS.JUDGEMENT_DATE_JAF}
                              name={REGULATIONS.JUDGEMENT_DATE_JAF}
                              id={REGULATIONS.JUDGEMENT_DATE_JAF}
                              value={get(
                                risk.regulationInfo,
                                [REGULATIONS.JUDGEMENT_DATE_JAF],
                                '',
                              )}
                              error={
                                get(
                                  messageError[risk.regulationId],
                                  [REGULATIONS.JUDGEMENT_DATE_JAF],
                                  '',
                                ) && isStepValidated[activeStep]
                              }
                            >
                              {[
                                ...judgementOnMerits,
                                ...(get(
                                  risk.regulationInfo,
                                  [REGULATIONS.IS_APPEAL],
                                  '',
                                ) &&
                                featureService.hasFeature(
                                  FEATURES.REGULATION_V2,
                                )
                                  ? props.judgementOnMeritsWithCivjvm
                                  : []),
                              ]
                                .filter(
                                  (item: any) =>
                                    get(item, 'procedureType', '') ===
                                    PROCEDURE_TYPES.FIRST_INSTANCE,
                                )
                                .map((el: Config) => (
                                  <MenuItem
                                    key={get(el, 'jom.id')}
                                    value={formatDate(
                                      get(el, JUDGEMENT_DATE, ''),
                                    )}
                                  >
                                    {formatDate(get(el, JUDGEMENT_DATE, ''))}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                    </>
                  )}
                </>
              )}

              {risk.riskName === RISK_NAME.CORPOREAL && (
                <>
                  {get(risk, 'regulationInfo.beneficiaryRecipient', '') ===
                    RECIPIENT.BNEJ && (
                    <>
                      <Grid item xs={4}>
                        <TextField
                          fullWidth
                          label={translate(messages.taxAmount, props)}
                          onChange={handleChange(risk)}
                          data-testid={REGULATIONS.BNEJ_TAX_AMOUNT}
                          name={REGULATIONS.BNEJ_TAX_AMOUNT}
                          error={
                            get(
                              messageError[risk.regulationId],
                              [REGULATIONS.BNEJ_TAX_AMOUNT],
                              '',
                            ) && isStepValidated[activeStep]
                          }
                          value={get(risk, 'regulationInfo.BNEJTaxAmount')}
                        />
                      </Grid>
                    </>
                  )}
                  {/* date de reglement */}
                  <Grid item xs={4}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={frLocale}
                    >
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        format={DATE_PICKET_FORMAT}
                        value={dateStringToLocalDate(
                          get(
                            risk.regulationInfo,
                            [REGULATIONS.REGULATION_DATE],
                            '',
                          ) as any,
                        )}
                        InputLabelProps={{
                          shrink: isEmpty(
                            get(
                              risk.regulationInfo,
                              [REGULATIONS.REGULATION_DATE],
                              '',
                            ),
                          )
                            ? false
                            : true,
                        }}
                        data-testid={REGULATIONS.REGULATION_DATE}
                        onChange={_ => handleChangeRegulationDate(risk, _)}
                        label={translate({ ...messages.regulationDate }, props)}
                        id="regulation-date"
                        error={
                          get(
                            messageError[risk.regulationId],
                            [REGULATIONS.REGULATION_DATE],
                            '',
                          ) && isStepValidated[activeStep]
                        }
                        helperText={
                          isStepValidated[activeStep] &&
                          get(
                            messageError[risk.regulationId],
                            [REGULATIONS.REGULATION_DATE],
                            null,
                          )
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label={translate(messages.costs, props)}
                      onChange={handleChange(risk)}
                      data-testid={REGULATIONS.DIRECT_INDEMNITY_COSTS}
                      name={REGULATIONS.DIRECT_INDEMNITY_COSTS}
                      value={get(
                        risk,
                        'regulationInfo.directIndemnityCosts',
                        '',
                      )}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="idd-label-id"
                        shrink={
                          isEmpty(get(risk, 'regulationInfo.isIDDChecked', ''))
                            ? false
                            : true
                        }
                      >
                        {translate(messages.iddField, props)}
                      </InputLabel>
                      <Select
                        labelId="idd-label-id"
                        onChange={handleChange(risk)}
                        value={get(risk, 'regulationInfo.isIDDChecked', '')}
                        labelWidth={LABEL_WIDTH}
                        id={REGULATIONS.IS_IDD_CHECKED}
                        name={REGULATIONS.IS_IDD_CHECKED}
                      >
                        {IDD_LIST.map((idd: any) => {
                          return (
                            <MenuItem key={idd.id} value={idd.value}>
                              {idd.value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  {get(risk, 'regulationInfo.isIDDChecked') === 'Oui' && (
                    <>
                      <Grid item xs={4}>
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={frLocale}
                        >
                          <KeyboardDatePicker
                            autoOk
                            variant="inline"
                            format={DATE_PICKET_FORMAT}
                            id="calculation-start-date"
                            invalidDateMessage=""
                            onChange={_ => handleChangeIDDDate(risk, _)}
                            value={dateStringToLocalDate(
                              get(
                                risk,
                                'regulationInfo.calculationStartDate',
                                '',
                              ) as string,
                            )}
                            label={translate(messages.iddDate, props)}
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>
                      <Grid item xs={4}>
                        <FormControl fullWidth>
                          <InputLabel id="idd-label-id">
                            {translate(messages.iddDeduction, props)}
                          </InputLabel>
                          <Select
                            onChange={handleChange(risk)}
                            data-testid={REGULATIONS.DEDUCTION_RATE}
                            name={REGULATIONS.DEDUCTION_RATE}
                            id={REGULATIONS.DEDUCTION_RATE}
                            value={get(
                              risk,
                              'regulationInfo.deductionRate',
                              '',
                            )}
                          >
                            {get(listings, 'regulationIddDeduction', []).map(
                              (el: Config) => (
                                <MenuItem
                                  data-testid={el.percentage}
                                  key={el.id}
                                  value={el.percentage}
                                >
                                  {`${el.percentage} %`}
                                </MenuItem>
                              ),
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
            <article className="jom-validation">
              {getJomValidatorMessage(
                risk,
                get(isRegulationValidated[activeStep], 'message', null),
              )}

              {!isEmpty(
                get(risk.regulationInfo, [REGULATIONS.JUDGEMENT_DATE], ''),
              ) &&
                (risk.riskName === RISK_NAME.CORPOREAL
                  ? isJomValidated['rcCorpo']
                  : isJomValidated['rcMaterial']) &&
                translate(messages.jomValidation, props)}
            </article>
            <article className="jom-validation">
              {get(risk.regulationInfo, [REGULATIONS.STATUS], '') ===
                STATUS_VALIDATED_WITHOUT_CONTESTATION &&
                isNatureRegulationPartial(
                  get(risk.regulationInfo, REGULATIONS.REGULATION_NATURE),
                  get(listings, 'EncryptDocumentNature', []),
                ) &&
                translate(messages.jomPartialValidation, props)}
            </article>
            <article className="jom-validation">
              {isCDRATownDifferent(get(listings, 'villes', []), risk) &&
                translate(messages.alertCity, props)}
            </article>
          </>
        </SahamAccordion>
      )}
    </StyledDiv>
  );
};

export default injectIntl(RegulationInformationByRisk);
